module.exports = __webpack_public_path__ + "static/media/eazydiner.dc468e55.svg";